var _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 17,
    height: 17,
    transform: "matrix(-1 0 0 1 17 0)",
    stroke: "#13801C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.92188,
    cy: 4.92188,
    r: 4.92188,
    transform: "matrix(-1 0 0 1 13.9219 4.07812)",
    fill: "#13801C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/Pointer.23a5c93d0ee98c754e7aace5045f40aa.svg";
export { ForwardRef as ReactComponent };